import { useSearchParams } from 'react-router-dom';

export function useUrlSearchParams() {
  const [searchParams, setSearchParams] = useSearchParams();

  const updateParams = (updates: Record<string, string>) => {
    setSearchParams((prev) => {
      const next = new URLSearchParams(prev);
      Object.entries(updates).forEach(([key, value]) => {
        if (value) {
          next.set(key, value);
        } else {
          next.delete(key);
        }
      });
      return next;
    });
  };

  return {
    searchParams,
    setSearchParams,
    updateParams,
  };
}
